import Headline from "components/atoms/headline/Headline";
import { FC, useEffect, useState } from "react";
import LeadStatistics from "./Leads/LeadStatistics";
import AppointmentStatistics from "./Appointments/AppointmentStatistics";
import CustomerStatistic from "./Customers/CustomerStatistic";
import { getUsersByPermission } from "api/User";
import Leaderboard from "./Leaderboard/Leaderboard";
import NumberOfLeadsAppCust from "./GeneralStatistics/NumberOfLeadsAppCust";
import ConfirmedAppointments from "./Appointments/ConfirmedAppointments";
import ConditionalRender from "components/atoms/conditional-render/ConditionalRender";
import { usePermissions } from "lib/hooks/shared/usePermissions";


export interface IStatisticsProps { }

const Statistics: FC<IStatisticsProps> = () => {

    const [fetchedUsers, setFetchedUsers] = useState<Array<string>>([]);

    const hasPermissionToViewConfirmedAppointmentsTodayTomorrow = usePermissions(['statistics_confirmed_appointments_today_tomorrow_view']);
    const hasPermissionToViewGeneralStatistics = usePermissions(['statistics_general_view']);
    const hasPermissionToViewLeaderboard = usePermissions(['statistics_leaderboard_view']);

    const hasPermissionToViewLeadsFeedback = usePermissions(['statistics_leads_feedback_view']);
    const hasPermissionToViewOwnLeadsFeedback = usePermissions(['statistics_leads_feedback_view_view_own']);

    const hasPermissionToViewAppointmentFeedback = usePermissions(['statistics_appointments_feedback_view']);
    const hasPermissionToViewOwnAppointmentFeedback = usePermissions(['statistics_appointments_feedback_view_view_own']);

    const hasPermissionToViewCustomerProdFeedback = usePermissions(['statistics_customers_product_feedback_view']);
    const hasPermissionToViewOwnCustomerProdFeedback = usePermissions(['statistics_customers_product_feedback_view_view_own']);
    useEffect(() => {

        getUsersByPermission({
            permissions: ['lead_view_view_own'],

        })
            .then((res) => {
                setFetchedUsers(res.users);
            })
            .catch(() => { });
        // eslint-disable-next-line
    }, []);

    return (
        <>

            <Headline title={'Statistics'} />

            <div className="flex gap-4 flex-col xl:flex-row ">
                <ConditionalRender condition={hasPermissionToViewGeneralStatistics}>
                    <div className="w-full xl:max-w-[300px] 2xl:max-w-[400px]">
                        <NumberOfLeadsAppCust />
                    </div>
                </ConditionalRender>
                <ConditionalRender condition={hasPermissionToViewConfirmedAppointmentsTodayTomorrow}>
                    <div className={`flex flex-col gap-4 sm:flex-1`}>
                        <ConfirmedAppointments />
                    </div>
                </ConditionalRender>
            </div>
            <div className="flex gap-4 flex-col 2xl:flex-row mt-4">



                <div className={`flex flex-col gap-4  basis-full xl:basis-3/4`}>
                    <ConditionalRender condition={hasPermissionToViewLeadsFeedback || hasPermissionToViewOwnLeadsFeedback}>
                        <LeadStatistics fetchedUsers={fetchedUsers} />
                    </ConditionalRender>

                    <ConditionalRender condition={hasPermissionToViewAppointmentFeedback || hasPermissionToViewOwnAppointmentFeedback}>
                        <AppointmentStatistics fetchedUsers={fetchedUsers} />
                    </ConditionalRender>

                    <ConditionalRender condition={hasPermissionToViewCustomerProdFeedback || hasPermissionToViewOwnCustomerProdFeedback}>
                        <CustomerStatistic fetchedUsers={fetchedUsers} />
                    </ConditionalRender>


                </div>
                <ConditionalRender condition={hasPermissionToViewLeaderboard}>
                    <div className="basis-full xl:basis-1/4">
                        <Leaderboard />
                    </div>
                </ConditionalRender>

            </div>
        </>
    );
};

export default Statistics;
